import listData from './listStore'
import addConfigData from './addConfigStore'
import detailData from './detailStore'
import filterData from './filterStore'
import listTabData from './listTabStore'
import exportData from './exportStore'
import exportClueData from './exportClueStore'
import auditData from './auditStore'
import repeatData from './repeatStore'
import relateData from './inqueryCommonStore.js'
import fieldsData from './fieldConfigStore'
import clue from './clue'
// import i18n from '@/lib/language'

/* export const allFieldType = {
  '1': {
    desc: i18n.t('message["1265"]'),
    type: 'text',
    format: 'string',
    default: ''
  },
  '2': {
    desc: i18n.t('message["328"]'),
    type: 'editor',
    format: 'string',
    default: ''
  },
  '3': {
    desc: i18n.t('message["150"]'),
    type: 'radio',
    format: 'int',
    default: 0
  },
  '4': {
    desc: i18n.t('message["263"]'),
    type: 'checkbox',
    format: 'array|int',
    default: []
  },
  '5': {
    desc: i18n.t('message["209"]'),
    type: 'area',
    format: 'string',
    default: ''
  },
  '6': {
    desc: i18n.t('message["1142"]'),
    type: 'select_tree',
    format: 'array|int',
    default: []
  },
  '7': {
    desc: i18n.t('message["1268"]'),
    type: 'file',
    format: '',
    default: []
  },
  '8': {
    desc: i18n.t('message["52"]'),
    type: 'tag',
    format: 'array|string',
    default: []
  },
  '9': {
    desc: i18n.t('message["1141"]'),
    type: 'number',
    format: 'number',
    default: 0
  },
  '10': {
    desc: i18n.t('message["1075"]'),
    type: 'datetime',
    format: 'datetime',
    default: ''
  },
  '11': {
    desc: i18n.t('message["1417"]'),
    type: 'select',
    format: 'int',
    default: 0
  },
  '12': {
    desc: i18n.t('message["1235"]'),
    type: 'radioinfo_payfor',
    format: 'int',
    default: 0
  },
  '13': {
    desc: i18n.t('message["1359"]'),
    type: 'radioinfo_level',
    format: 'int',
    default: 0
  },
  '14': {
    desc: i18n.t('message["1373"]'),
    type: 'radioinfo_type',
    format: 'int',
    default: 0
  },
  '15': {
    desc: i18n.t('message["376"]'),
    type: 'radioinfo_followup',
    format: 'int',
    default: 0
  },
  '16': {
    desc: i18n.t('message["1505"]'),
    type: 'email',
    format: 'string',
    default: 0
  },
  '17': {
    desc: i18n.t('message["1112"]'),
    type: 'phone',
    format: 'string',
    default: 0
  }
} */

export default {
  namespaced: true,
  modules: {
    listData,
    addConfigData,
    detailData,
    filterData,
    listTabData,
    exportData,
    auditData,
    repeatData,
    relateData,
    fieldsData,
    clue,
    exportClueData
  }
}
